<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
    </div>
    <div id="menu"></div>
    <div id="center">
      <div
        id="content"
        class="content"
      >
        <div class="center_content">
          <form
            id="searchSection"
            onSubmit="return false;"
          >
            <div class="menu">
              <div class="menubox hidebox">
                <div class="sort clearfix">
                  <div class="title">专业大类</div>
                  <div class="tab-list subjectList">
                    <ul class="clearfix">
                      <li
                        @click="queryInfo.subject_category_id = '', queryInfo.subject_id = '', queryInfo.year = '', queryInfo.auth_exp_level = '', search()"
                        :class="queryInfo.subject_category_id == '' ? 'on' : ''"
                      >全部</li>
                      <li
                        v-for="(item,index) in categoryData"
                        @click="queryInfo.subject_category_id = item.id, queryInfo.subject_id = '', queryInfo.year = '', queryInfo.auth_exp_level = '', search()"
                        :key="index"
                        :class="queryInfo.subject_category_id == item.id ? 'on' : ''"
                      >{{item.title}}({{item.exp_count}})</li>
                    </ul>
                  </div>
                </div>
                <div
                  class="sort clearfix subject2Wrap"
                  :class="queryInfo.subject_category_id ? '' : 'hide'"
                >
                  <div class="title">专业分类</div>
                  <div class="tab-list subject2List">
                    <ul class="clearfix">
                      <li
                        @click="queryInfo.subject_id='', queryInfo.year = '', queryInfo.auth_exp_level = '',search()"
                        :class="queryInfo.subject_id == '' ? 'on' : ''"
                      >全部</li>
                      <li
                        @click="queryInfo.subject_id=item.id, queryInfo.year = '', queryInfo.auth_exp_level = '',search()"
                        v-for="(item,index) in subjectData"
                        :key="index"
                        :class="queryInfo.subject_id == item.id ? 'on' : ''"
                      >{{item.title}}({{item.exp_count}})</li>
                    </ul>
                  </div>
                </div>
                <div class="sort clearfix subject2Wrap">
                  <div class="title">获奖年份</div>
                  <div class="tab-list subject2List">
                    <ul class="clearfix">
                      <li
                        @click="queryInfo.year='', queryInfo.auth_exp_level = '',search()"
                        :class="queryInfo.year.toString() == '' ? 'on': ''"
                      >全部</li>
                      <li
                        v-for="(item,index) in yearData"
                        :key="index"
                        @click="queryInfo.year=item.id, queryInfo.auth_exp_level = '',search()"
                        :class="queryInfo.year.toString() == item.id.toString() ? 'on': ''"
                      >{{ item.title == 0 ? '未设置' : item.title }}({{ item.exp_count }})</li>
                    </ul>
                  </div>
                </div>
                <div class="sort clearfix subject2Wrap">
                  <div class="title">获奖级别</div>
                  <div class="tab-list subject2List">
                    <ul class="clearfix">
                      <li
                        @click="queryInfo.auth_exp_level='',search()"
                        :class="queryInfo.auth_exp_level.toString() == '' ? 'on': ''"
                      >全部</li>
                      <li
                        v-for="(item,index) in levelData"
                        :key="index"
                        @click="queryInfo.auth_exp_level=item.id,search()"
                        :class="queryInfo.auth_exp_level.toString() == item.id.toString() ? 'on': ''"
                      >{{ item.id in dict_auth_exp_level ? dict_auth_exp_level[item.id] : '其他' }}({{ item.exp_count }})</li>
                    </ul>
                  </div>
                </div>
                <div class="sort clearfix">
                  <div class="title">关&nbsp;&nbsp;键&nbsp;&nbsp;词</div>
                  <div class="edit"><input
                      type="text"
                      v-model="queryInfo.experiment_title"
                      placeholder="请输入实验名称"
                      autocomplete="off"
                    ><input
                      type="text"
                      v-model="queryInfo.school_title"
                      placeholder="请输入学校名称"
                      autocomplete="off"
                    ><input
                      type="text"
                      class="school-title"
                      v-model="queryInfo.master_name"
                      placeholder="请输入负责人名称"
                      autocomplete="off"
                    ><button
                      type="submit"
                      class="s-btn search"
                      style="margin-bottom:0"
                      @click="pageCallback(1)"
                    >搜索</button></div>
                </div>
              </div>
            </div>
          </form>

          <div class=" hidebox list-wrap clearfix ">
            <div class="list-order">
              <div>
                <span>排序:</span>
                <span
                  class="active"
                  @click="queryInfo.order='auth_year desc, pubDate desc',getExperiment()"
                >最新</span>
                <span
                  @click="queryInfo.order='appraise_avg desc',getExperiment()"
                >评分</span>
                <span
                  @click="queryInfo.order='collect_count desc',getExperiment()"
                >收藏</span>
              </div>
              <span v-if="searchText && searchText.length">共找到{{tableDataCount}}个包含 “<strong>{{searchText}}</strong>” 的结果</span>
            </div>
            <div class="f-box">
              <ul
                class="project-list clearfix"
                id="projectList"
              >
                <li
                  v-for="item in tableData"
                  :key="item.id"
                >
                  <router-link :to="'/www/experiment?id=' + item.id">
                    <div class="bg">
                      <div class="imgWrap">
                        <template>
                          <span
                            class="mark mark0"
                            v-if="item.auth_exp_level==1"
                          >国</span>
                          <span
                            class="mark mark1"
                            v-if="item.auth_exp_level==2"
                          >省</span>
                          <span
                            class="mark mark2"
                            v-if="item.auth_exp_level==3"
                          >校</span>
                        </template>
                        <img
                          :src="item.logo"
                          :onerror="$store.state.defaultImg"
                        >
                      </div>
                      <div class="text-wrap">
                        <div class="text-title">
                          <p>{{item.title}}</p>
                          <span class="num">{{ item.appraise_avg.toFixed(1)}}</span>
                        </div>
                        <div>
                          <div class="p2">
                            <div>
                              <span class="m-r-md">
                                {{item.school_title ? item.school_title : '--'}}
                              </span>|<span class="m-l-md">{{item.master_name?item.master_name:'--'}}</span>
                            </div>
                            <div>
                              <span class="spanUser"><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}</span>
                              <span class="spanUser"><i class="iconfont">&#xe62f;</i>{{item.view_count?item.view_count:'0'}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
              <div
                class="no-more"
                v-if="!tableData.length"
              >
                暂无数据
              </div>
            </div>
            <pagination
              v-if="tableData.length"
              :cur='pageInfo.page'
              :all='pageInfo.all'
              :totalData="pageInfo.totalData"
              :callback="pageCallback"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import Pagination from '../../../components/Pager'

export default {
  name: 'Search',
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科,建设成果' }
    ]
  },
  components: {
    HeaderInfo,
    FooterInfo,
    Pagination
  },
  data() {
    return {
      categoryData: [],
      subjectData: [],
      yearData: [],
      levelData: [],
      tableData: [],
      tableDataCount: 0,
      searchText: '',
      queryInfo: {
        page: 1,
        size: 9,
        subject_category_id: '',
        subject_id: '',
        year: '',
        auth_exp_level: '',
        experiment_title: '',
        school_title: '',
        master_name: '',
        order: 'auth_year desc, pubDate desc'
      },
      isShow: false,
      heatRank: [],
      showPicker: false
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    dict_auth_exp_level() {
      return this.$store.state.dict_auth_exp_level
    }
  },
  methods: {
    pageCallback(data) {
      this.queryInfo.page = data
      this.getExperiment()
    },
    // 获取分类
    async getFilter() {
      await this.$http.get('/experiment_search_filter/', {
        params: {
          subject_category_id: this.queryInfo.subject_category_id,
          subject_id: this.queryInfo.subject_id,
          year: this.queryInfo.year
        }
      }).then((data) => {
        if (data.code === '200') {
          this.categoryData = data.data.sc_dict
          this.subjectData = data.data.s_dict
          this.yearData = data.data.year_dict
          this.levelData = data.data.level_dict
        } else {
          this.$layer.msg('获取信息失败！')
        }
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 获取实验
    async getExperiment() {
      await this.$http.get('/experiment_search/', {
        params: this.queryInfo
      }).then((data) => {
        this.searchText = this.queryInfo.experiment_title
        this.tableData = data.data.results
        this.tableDataCount = data.data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 搜索
    search() {
      this.getFilter()
      this.getExperiment()
    }
  },
  created() {
    if (this.$route.query.t) {
      const t = this.utils.decryptDes(this.$route.query.t)
      this.queryInfo.auth_exp_level = t
    }
    if (this.$route.query.n) {
      const n = this.utils.decryptDes(this.$route.query.n)
      this.queryInfo.experiment_title = n
    }
    this.search()
  },
  mounted() {
  }
}
</script>
<style scoped src="../../../assets/css/dialog.css"></style>
<style scoped src="../../../assets/css/common.css"></style>
<style scoped src="../../../assets/css/header.css"></style>
<style scoped src="../../../assets/css/project-list.css"></style>
<style lang="less" scoped>
/deep/.header_container {
  .logo {
    width: 245.5px;
    height: 80px;
    background: url(../../../assets/images/logo.png) no-repeat center center;
    background-size: 100%;
    margin-left: 4.2%;
  }
}
#searchSection .s-btn:hover {
  background: #12BDAA;
}
.hideActive {
  display: none;
}
.showActive {
  display: block;
}
.imgWrap {
  position: relative;
}
.mark {
  position: absolute;
  left: 0;
  top: 0;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  border-bottom-right-radius: 5px;
}
.mark0 {
  background: #eb6736;
}
.mark1 {
  background: #009999;
}
.mark2 {
  background: #ff9000;
}
.list-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  .f-box {
    width: 1200px;
    margin: 0 auto 30px;
    float: none;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
    ul {
      li {
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}

.imgWrap img {
  width: 350px;
  height: 183px;
  transition: 0.5s;
}

.experiment-pop {
  width: 370px;
  height: 248px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(50, 50, 50, 0.6);
  opacity: 0;
  transition: all 0.5s;
}
.experiment-pop .editbox {
  padding: 20px;
}
.experiment-pop .editbox .word {
  font-size: 16px;
  color: #fff;
  margin-top: 10px;
}
.experiment-pop .editbox .intro {
  color: #ddd;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}
#app #center {
  padding-bottom: 0;
}
.menu {
  width: 100%;
  min-height: 310px;
  //background: url(../../../assets/images/bg.jpg) no-repeat;
  background-color: #BDEBE6;
  //background-size: 100% 100%;
}
.center_content {
  padding-bottom: 80px;
}
.list-order {
  width: 1200px;
  margin: 0 auto 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    span {
      margin-right: 20px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      &:first-child {
        color: #97aecb;
        cursor: default;
      }
      &.active {
        color: #2454c0;
        border-bottom: 2px solid #2454c0;
      }
    }
  }
  & > span {
    font-size: 13px;
    color: #686868;
    strong {
      color: #333;
    }
  }
}
.text-wrap {
  .text-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    p {
      font-size: 15px;
      color: #333;
    }
    span {
      color: #f37200;
      font-size: 40px;
      font-family: Microsoft YaHei, Helvetica, STHeiti STXihei,
        Microsoft JhengHei, Arial !important;
    }
  }
  .p2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 !important;
  }
  .m-r-md,
  .m-l-md {
    margin: 0;
  }
  .m-r-md {
    margin-right: 5px;
  }
  .m-l-md {
    margin-left: 5px;
  }
  .spanUser {
    margin-left: 10px;
  }
}
.mark {
  position: absolute;
  left: unset;
  right: 20px;
  top: 0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  padding: 0;
  font-size: 12px;
  color: #fff;
  border-bottom-right-radius: 0px;
}
.no-more {
  text-align: center;
  line-height: 40px;
  color: #999;
}
.load-more {
  width: 100px;
  height: 30px;
  border: 1px solid #73D6CA;
  text-align: center;
  line-height: 30px;
  color: #73D6CA;
  margin: 20px auto;
  position: relative;
  z-index: 100;
}
</style>
